module.exports = "<footer >      \n    Smartenit Inc., Copyright 2018\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.html
// module id = ./src/app/components/footer/footer.html
// module chunks = main